import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import * as FIELDS from '../../fields';
import { DMA_REPORT_ID } from './dmaReportId';

const emptyColumns = [FIELDS.DMA_CODE].map(createFooterMapper(DMA_REPORT_ID));

const dmaReportFooterColumnDefinition = [...emptyColumns];

export default dmaReportFooterColumnDefinition;
